import { render, staticRenderFns } from "./ConstitucionSociedades.vue?vue&type=template&id=3bec9a3b"
import script from "./ConstitucionSociedades.vue?vue&type=script&lang=js"
export * from "./ConstitucionSociedades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bec9a3b')) {
      api.createRecord('3bec9a3b', component.options)
    } else {
      api.reload('3bec9a3b', component.options)
    }
    module.hot.accept("./ConstitucionSociedades.vue?vue&type=template&id=3bec9a3b", function () {
      api.rerender('3bec9a3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/ConstitucionSociedades.vue"
export default component.exports